"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intentionsBalances = intentionsBalances;

var _operators = require("rxjs/operators");

var _balances = require("../balances");

var _drr = require("../util/drr");

// Copyright 2017-2019 @polkadot/api-derive authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * Get the balances for all intentions and their nominators
 */
function intentionsBalances(api) {
  return () => // tslint:disable-next-line
  api.query.staking.intentions().pipe((0, _operators.switchMap)((0, _balances.validatingBalances)(api)), (0, _drr.drr)());
}